// A small curated set for the chat composer. Emoji are plain Unicode, so they
// need no storage change — they travel in the message body like any other text.
export const EMOJI: string[] = [
  '😀', '😂', '🤣', '😊', '😉', '😍', '😘', '😜', '🤪', '😎',
  '🤔', '😏', '😴', '🥴', '🫠', '😭', '😡', '🤬', '😱', '🤯',
  '👍', '👎', '👏', '🙌', '🙏', '💪', '🤝', '👊', '✌️', '🤞',
  '❤️', '🔥', '⭐', '✨', '🎉', '💯', '🎵', '🎶', '🎸', '🎧',
  '🍺', '🍻', '🥂', '👀', '🙈', '💀', '🧀', '🐐', '🚀', '🫡',
];
